import { useState } from "react";
import emailjs from "@emailjs/browser";
import { fetchGETRequest } from "../utils/services";
import { fallBackMailForBalanceNotif } from "../utils/constants";

// Types
interface EmailData {
  message: string;
  balance: string | number;
  [key: string]: any;
}

interface DeviceData {
  customerId: {
    id: string;
  };
  name: string;
  [key: string]: any;
}

interface ConsumerData {
  email?: string;
  [key: string]: any;
}

interface EmailJSResponse {
  status: number;
  text: string;
}

interface UseEmailJSReturn {
  sendEmail: (data: EmailData, meterId: string) => Promise<EmailJSResponse>;
  loading: boolean;
}

const useEmailJS = (): UseEmailJSReturn => {
  const [loading, setLoading] = useState<boolean>(false);

  const sendEmail = async (
    data: EmailData,
    meterId: string
  ): Promise<EmailJSResponse> => {
    setLoading(true);
    console.log("Email sending...");

    try {
      if (!meterId) {
        throw new Error("Meter Id not found.");
      }

      const deviceResponse = await fetchGETRequest(`device/${meterId}`);
      const deviceData: DeviceData =
        (deviceResponse as any)?.data || deviceResponse;
      if (!deviceData) {
        throw new Error("Device data not found.");
      }

      const customerId = deviceData?.customerId?.id;
      if (!customerId) {
        throw new Error("Customer ID not found in device data.");
      }

      const custResponse = await fetchGETRequest(`v2/Customers/${customerId}`);
      const consumerData: ConsumerData = custResponse?.data?.data || custResponse?.data || {};
      if (!consumerData || Object.keys(consumerData).length === 0) {
        throw new Error("Consumer data not found.");
      }

      const emailData = {
        ...data,
        email:
          consumerData?.email ||
          fallBackMailForBalanceNotif ||
          "kaushik@voltreum.com",
        meterNumber: deviceData?.name,
        message: `${data.message} \n Meter Number: ${deviceData?.name} \n Wallet Balance: ${data.balance}`,
      };

      console.log("Prepared email data:", emailData);

      const response: EmailJSResponse = await emailjs.send(
        "service_8a2dbjk",
        "template_j3o0qtq",
        emailData,
        "5XwOqvL0ajxHeBnfC"
      );

      return response;
    } catch (error) {
      console.error("Error while sending email:", error);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return { sendEmail, loading };
};

export default useEmailJS;
